<template>
    <div>
        <p class="text-smaller">{{ __('manage_poi.notifications.email_addresses') }}</p>
        <div v-for="(email, index) in emailAddresses" :key="index" class="email-input-group mt-2">
            <input
                type="email"
                v-model="emailAddresses[index]"
                @input="updateEmails"
                class="form-control text-smaller"
                :placeholder="__('manage_poi.notifications.insert')"
            />
            <golia-button
                @click="removeEmail(index)"
                variant="btn-sm btn-danger"
                icon="fa-fw fa-trash"
            />
        </div>
        <golia-button
            @click="addEmail"
            variant="btn-sm btn-info"
            icon="fa-fw fa-plus"
            :label="__('manage_poi.notifications.add_email')"
        />
    </div>
</template>

<script>
export default {
    name: 'PoiSettings',
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        emailAddresses: {
            get() {
                return this.value.emailAddresses || []
            },
            set(newEmails) {
                this.$emit('input', { ...this.value, emailAddresses: newEmails })
            }
        }
    },
    methods: {
        addEmail() {
            this.emailAddresses.push('')
        },
        removeEmail(index) {
            this.emailAddresses.splice(index, 1)
        },
        updateEmails() {
            this.$emit('input', { ...this.value, emailAddresses: this.emailAddresses })
        }
    }
}
</script>

<style scoped>
.email-input-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.email-input-group input {
    flex: 1;
    margin-right: 10px;
}
</style>
